import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";

import { selectIsMovieFetching } from "../../Redux/Movie/movie-selectors";

import WithSpinnerItem from "../WithSpinner/WithSpinnerItem";
import EventPageOverview from "./EventPageOverview";

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsMovieFetching,
});

const EventPageOverviewContainer = compose(
  connect(mapStateToProps),
  WithSpinnerItem
)(EventPageOverview);

export default EventPageOverviewContainer;
